export default __webpack_public_path__ + "static/media/404.6f4f6cbd.svg";